// Generated by CoffeeScript 2.7.0
var PayloadItem;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

export default PayloadItem = Vue.extend({
  components: {
    'Popover': Popover,
    'group-options': GroupOptions
  },
  props: {
    initialPayload: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data: function() {
    return {
      payload: this.initialPayload,
      hour: parseInt(this.initialPayload.waiting / 60) || 0,
      minute: this.initialPayload.waiting % 60 || 0
    };
  },
  template: `<div class="form-field-group inline mb-4 push-payload">
  <div class="form-field inline mr-6">
    <div class="form-field-head mr-2">
      <div class="field-title">推送方式：</div>
    </div>
    <div class="form-field-input-container">
      <div class="form-field-input">
        <Popover :blockContent='true'
                 customClass='push-popover select'
                 position='bottom'
                 ref="tagsSelectPopoverRef">
          <template slot='trigger'>
            <div class="input-control justify-box right-addon">
              <div class="controlled-input"
                   v-show='displayValue'>{{ displayValue }}</div>
              <div class="controlled-input placeholder"
                   v-show='!displayValue'>请选择</div>
              <div class="addon">
                <i class="slp-caret-down"></i>
              </div>
            </div>
          </template>
          <template slot='content'>
            <group-options :groupedOptions='groupedOptions'
                           :multiple="false"
                           @valueChanged="pushTypeChangeFunc"
                           ref='groupedOptionsRef'>
              <template slot='option-item-template' slot-scope='{ option }'>
                <div class='content'>
                  <span>{{ option.name }}</span>
                </div>
                <i class='tip'
                   :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
              </template>
            </group-options>
          </template>
        </Popover>
      </div>
    </div>
  </div>
  <div class="form-field inline mr-6">
    <div class="form-field-head mr-2">
      <div class="field-title">推送时间：</div>
    </div>
    <div class="form-field-input-container">
      <div class="form-field-input options">
        <label class="option-item">
          <input type="number"
                 value="0"
                 v-model.number="hour"
                 @focus="focusFunc">
          <span>小时</span>
        </label>
        <label class="option-item">
          <input type="number"
                 value="0"
                 v-model.number="minute"
                 @focus="focusFunc">
          <span>分钟</span>
        </label>
      </div>
    </div>
  </div>
  <button class="text-btn btn-danger"
          @click="deletePayload">删除</button>
</div>`,
  watch: {
    hour: function(val) {
      if (val === '') {
        this.hour = 0;
      }
      return this._calculateWaiting();
    },
    minute: function(val) {
      if (val === '') {
        this.minute = 0;
      }
      if (val > 59) {
        this.minute = 59;
      }
      return this._calculateWaiting();
    }
  },
  computed: {
    options: function() {
      var options;
      options = [
        {
          push_type: 'Push::CustomMessage',
          name: '微信',
          _selected: true
        },
        {
          push_type: 'Push::Sms',
          name: '短信',
          _selected: false
        },
        {
          push_type: 'Push::Call',
          name: '电话',
          _selected: false
        }
      ];
      return _.map(options, (option) => {
        if (option.push_type === this.initialPayload.push_type) {
          option._selected = true;
        } else {
          option._selected = false;
        }
        return option;
      });
    },
    displayValue: function() {
      var name;
      name = '';
      _.map(this.options, function(option) {
        if (option._selected) {
          return name = option.name;
        }
      });
      return name;
    },
    groupedOptions: function() {
      return [
        {
          allow_clear: false,
          options: this.options
        }
      ];
    }
  },
  methods: {
    pushTypeChangeFunc: function(_vm, option) {
      this.payload.push_type = option.push_type;
      return this.$emit('payloadChanged', this.index, this.payload);
    },
    focusFunc: function(event) {
      return event.target.select();
    },
    deletePayload: function() {
      return this.$emit('deletedPayload', this.index, this.payload);
    },
    _calculateWaiting: function() {
      this.payload.waiting = this.hour * 60 + this.minute;
      return this.$emit('payloadChanged', this.index, this.payload);
    }
  }
});
